import React from 'react';
import { 
  LayoutGrid, Calendar, MessageSquare, Target, BarChart3, 
  Layers, CheckSquare, Sparkles 
} from 'lucide-react';
import { FullProject } from '../../types';

interface SubHeaderIdentityProps {
  viewMode: string;
  projectName: string;
  activeProject: FullProject | null;
  isReadOnly?: boolean;
  calendarDate: Date;
}

export const SubHeaderIdentity: React.FC<SubHeaderIdentityProps> = ({
  viewMode,
  projectName,
  activeProject,
  isReadOnly = false,
  calendarDate
}) => {
  let icon = <LayoutGrid className="w-5 h-5" />;
  let title = projectName || 'Projekt wählen';
  let colorClass = activeProject?.color || 'bg-indigo-500';

  if (viewMode === 'globalKanban') {
    icon = <CheckSquare className="w-5 h-5" />;
    title = 'Aufgaben';
    colorClass = 'bg-indigo-600';
  } else if (viewMode === 'communication') {
    icon = <MessageSquare className="w-5 h-5" />;
    title = 'Kommunikation';
    colorClass = 'bg-blue-600';
  } else if (viewMode === 'analysis' || viewMode === 'impactEffort') {
    icon = <Target className="w-5 h-5" />;
    title = 'Analyse';
    colorClass = 'bg-emerald-600';
  } else if (viewMode === 'metricsDashboard') {
    icon = <BarChart3 className="w-5 h-5" />;
    title = 'Fortschritt';
    colorClass = 'bg-purple-600';
  } else if (viewMode === 'globalCalendar' || viewMode === 'dashboard') {
    icon = <Calendar className="w-5 h-5" />;
    title = 'Kalender';
    colorClass = 'bg-amber-600';
  } else if (viewMode === 'aiAssistant') {
    icon = <Sparkles className="w-5 h-5" />;
    title = 'KI Assistenten Hub';
    colorClass = 'bg-indigo-600';
  } else if (viewMode === 'globalGantt') {
    icon = <Layers className="w-5 h-5" />;
    title = 'Gantt';
    colorClass = 'bg-teal-600';
  } else if (viewMode === 'calendar') {
    icon = <Calendar className="w-5 h-5" />;
    title = projectName;
    colorClass = activeProject?.color || 'bg-indigo-500';
  } else if (viewMode === 'projectContact') {
    icon = <MessageSquare className="w-5 h-5" />;
    title = projectName;
  }

  const isGlobalView = [
    'globalKanban', 'communication', 'analysis', 'impactEffort', 
    'metricsDashboard', 'globalCalendar', 'dashboard', 'aiAssistant', 'globalGantt'
  ].includes(viewMode);

  return (
    <div className="flex-1 flex items-center gap-4 min-w-0">
      <div className="flex items-center gap-3 whitespace-nowrap min-w-0">
        <div className={`w-10 h-10 rounded-xl ${colorClass.startsWith('bg-') ? colorClass : `bg-${colorClass}`} flex items-center justify-center text-white shadow-sm shrink-0`}>
          {icon}
        </div>
        <div className="flex items-center gap-3 min-w-0 mr-4">
          <span className="text-sm font-bold text-slate-800 dark:text-slate-100 tracking-tight uppercase truncate leading-none">
            {title}
          </span>
          {isReadOnly && !isGlobalView && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 text-[10px] font-black uppercase tracking-wider shadow-sm select-none border border-slate-200/50 dark:border-slate-700/50 shrink-0">
              🔒 Nur Lesen
            </span>
          )}
          {(viewMode === 'dashboard' || viewMode === 'globalCalendar') && (
            <>
              <span className="text-slate-300 dark:text-slate-700 text-sm select-none">|</span>
              <span className="text-xs font-black text-indigo-600 dark:text-indigo-400 select-none whitespace-nowrap uppercase tracking-wider bg-indigo-50/50 dark:bg-indigo-950/20 px-2.5 py-1 rounded-lg shrink-0">
                {calendarDate.toLocaleString('de-DE', { month: 'long', year: 'numeric' })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
